<template>
    <div>
      <div>
        <h1 class="h3 mb-3 text-gray-800">
          {{ $t("Concessão de Benefício") }}
        </h1>
        <div class="alert alert-info" v-if="showMsgQtd">
          Notamos que o Benefício selecionado não possui quantidade suficiente
          para esta concessão. Após o cadastro o Gestor(a) será notificado e
          avaliará a solicitação.
        </div>
        <form @submit.prevent="submit" ref="addItem">
          <!--Bloco Responsável Familiar-->
          <div class="row">
            <form-select
              v-model="beneficio.usuario_id"
              label="Usuário(s)"
              :itens="pessoas"
              :required="true"
            />
            <form-select
              v-model="beneficio.beneficio_id"
              label="Benefício"
              :itens="beneficios"
              :required="true"
              :disabled="beneficiosLoading"
              :loading="beneficiosLoading"
              :grid="!disabledQtd ? '8' : '12'"
              ajuda="Se o Benefício que você deseja liberar não for encontrado nas opções abaixo você deve cadastra  na página de gestão de benefícios ou solicitar o cadastro a quem tem permissões para realizar a ação"
            />
            <form-input
              v-model="beneficio.valor"
              label="Valor"
              grid="5"
              type="text"
              inputGroup="true"
              btnText="R$"
              @input="formatarValor"
              :disabled="disabledValor"
              v-if="!disabledValor"
            />
            <form-input
              v-model="beneficio.quantidade"
              label="Quantidade"
              grid="4"
              type="number"
              :required="true"
              :disabled="disabledQtd"
              :min="1"
              v-if="!disabledQtd"
            />
            <form-select
              v-model="beneficio.periodicidade"
              label="Periodicidade"
              grid="3"
              :itens="$root.arrays.beneficio_periodicidade"
            />
            <form-select
              v-model="beneficio.solicitante"
              label="Solicitante"
              grid="3"
              :itens="$root.arrays.solicitante"
              :required="true"
            />
            <form-input
              v-model="beneficio.nome_solicitante"
              label="Nome do Solicitante"
              grid="6"
              :required="true"
              :disabled="beneficio.solicitante == 1 ? true : false"
            />
            <form-textarea-editor
              v-model="beneficio.observacoes"
              grid="12"
              label="Observação"
            />
            <form-textarea-editor
              v-model="beneficio.parecer_tecnico"
              grid="12"
              label="Parecer Técnico"
            />
            <form-select
              v-model="beneficio.status_parecer"
              label="Status do Parecer"
              grid="12"
              :itens="$root.arrays.status_parecer"
              :required="true"
            />
          </div>
          <div class="row pt-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <a class="btn btn-default" @click="$emit('voltar')">
                <i class="mdi mdi-arrow-left" />
              </a>
              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="mdi mdi-content-save" />
                {{ $t("Salvar") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script>
export default {
  props: ["familia", "morph"],
  name: "Add",
  data() {
    return {
      beneficiosLoading: true,
      beneficio: {
        beneficio_id: null,
        nome_solicitante: "",
        situacao: "", // Corrigido typo "sitaucao" para "situacao".
      },
      beneficios: [],
      isGestor: false,
      disabledQtd: true,
      showMsgQtd: false,
      disabledValor: true,
    };
  },
  watch: {
    "beneficio.beneficio_id": function (val) {
      this.disabledQtd = this.beneficios.some(
        (item) => item.qtd === true && val == item.id
      )
        ? false
        : true;

      this.disabledValor = this.beneficios.some(
        (item) => item.categoria === 1 && val == item.id
      )
        ? false
        : true;
    },
    "beneficio.quantidade": function (val) {
      if (!this.disabledQtd) {
        this.showMsgQtd = this.beneficios.some(
          (item) =>
            item.qtd === true &&
            item.id == this.beneficio.beneficio_id &&
            item.quantidade_disponivel < val
        );
      }
    },
  },
  computed: {
    pessoas() {
      return this.familia.familiares
        .filter((elem) => elem.estado_cadastral_cadunico <= 3)
        .map((elem) => ({
          id: elem.id,
          value: elem.nome_social
            ? `${elem.nome_social} <b>${elem.idade} ano(s)</b>`
            : `${elem.nome_completo} <b>${elem.idade} ano(s)</b>`,
        }));
    },
  },
  mounted() {
    this.getBeneficios();
  },
  updated() {
    if (this.$store.state.user) {
      const role_user = this.$store.state.user.role_details.name;
      this.isGestor = role_user === "Gestor(a)" || role_user === "Admin";
    }
  },
  methods: {
    formatarValor() {
      if(!valor) return null;
			// Remove tudo o que não for número
			let valor = this.beneficio.valor.replace(/\D/g, '');

			// Adiciona o ponto de milhar e formata com a vírgula para centavos
			if (valor.length > 2) {
			  valor = valor.replace(/(\d)(\d{2})$/, '$1,$2');
			}
			if (valor.length > 6) {
			  valor = valor.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');
			}

			// Atualiza o valor formatado no v-model
			this.beneficio.valor = valor;

		},
    // Função para limpar a formatação e enviar apenas o valor numérico
		formatarParaSubmit(valorFormatado) {
      if(!valorFormatado) return null;
			// Remove todos os caracteres que não são números ou vírgula
			let valorLimpo = valorFormatado.replace(',', '.');

			return valorLimpo;

		},
    getBeneficios() {
      this.beneficiosLoading = true;
      axios
        .get(`api/dashboard/get/beneficios`)
        .then((response) => {
          this.beneficios = response.data;
        })
        .finally(() => {
          this.beneficiosLoading = false;
        });
    },
    submit() {

      this.beneficio.familia_id = this.$route.query.familia_id;

      if (this.beneficio.valor != null && this.beneficio.valor !== "") {

        // Antes de enviar para o banco, formatamos o valor corretamente
        let valorParaEnviar = this.formatarParaSubmit(this.beneficio.valor);

        // Agora, atualizamos o valor no objeto 'beneficio'
				this.beneficio.valor = valorParaEnviar;

      }

      const ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(
          `api/dashboard/familia/beneficio/concessao/store`,
          this.beneficio
        )
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          if (this.morph !== undefined) {
            this.$emit("reload");
          } else {
            this.$router.push(
              `/dashboard/familia/beneficio/edit/${response.data.data.id}`
            );
          }
        })
        .finally(() => {
          this.files = [];
        });
    },
    verificaCategoria(value) {
      const response = this.beneficios.find((elem) => elem.id == value);
      return response && response.categoria === 1 ? 1 : 2;
    },
  },
};
</script>

